// 消除魔法字符串
const Mobile = 'my-mobile'
// 1. 保存
export const setMobile = (MobileObj) => {
    localStorage.setItem(Mobile, JSON.stringify(MobileObj))
}

// 2. 获取
export const getMobile = () => {
    return JSON.parse(localStorage.getItem(Mobile))
}

// 3. 删除
export const removeMobile = () => {
    localStorage.removeItem(Mobile)
}